module.exports = __webpack_public_path__ + "static/img/COVER-2.d2ac4d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-2.png
// module id = fD1/
// module chunks = 31